import axiosClient from "../../../../../../axiosClient"

export default async (id) => {
    const result = await axiosClient.get(`/pre-check-geolocation/${id}`)
    return result.data
}
